import { lightTheme, darkTheme} from '../../theme';

export const LIGHT = lightTheme;
export const DARK = darkTheme;


